import { IconsProps } from './IconsProps';

const SelectStore = ({
  className = '',
  viewBox = '0 0 24 24',
  width = 24,
  height = 24,
  onClick,
  svgFill = 'currentColor',
  ariaLabel,
  ariaHidden,
}: IconsProps) => {
  return (
    <svg
      className={className}
      viewBox={viewBox}
      width={`${width}px`}
      height={`${height}px`}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      onClick={onClick}
      fill={svgFill}
      aria-label={ariaLabel}
      aria-hidden={ariaHidden}
    >
      <path
        d="M16.7766 5.22326L16.7767 5.22345C16.8933 5.33936 16.95 5.47251 16.95 5.625V17.4944C16.95 17.6741 16.7662 17.7951 16.6012 17.7241L12.1383 15.805C12.05 15.7671 11.95 15.7671 11.8617 15.805L7.39876 17.7241C7.23376 17.7951 7.05 17.674 7.05 17.4944V5.625C7.05 5.47251 7.10673 5.33936 7.22326 5.22345L7.22345 5.22326C7.33936 5.10673 7.47251 5.05 7.625 5.05H12H16.375C16.5275 5.05 16.6606 5.10673 16.7766 5.22326ZM5.95 19.0448C5.95 19.2961 6.20706 19.4655 6.43803 19.3664L11.9014 17.0217C11.9644 16.9947 12.0356 16.9947 12.0986 17.0217L17.562 19.3664C17.7929 19.4655 18.05 19.2961 18.05 19.0448V5.625C18.05 5.14612 17.8914 4.74574 17.5734 4.42764C17.2546 4.10891 16.8539 3.95 16.375 3.95H7.625C7.14611 3.95 6.74572 4.1089 6.42764 4.42764C6.1089 4.74572 5.95 5.14611 5.95 5.625V19.0448Z"
        fill={svgFill}
        stroke="black"
        strokeWidth="0.1"
      />
    </svg>
  );
};

export default SelectStore;
